module.exports = __webpack_public_path__ + "img/computer_front_end.3f3b2c22.svg";